var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-403"},[_c('div',{staticClass:"text-center my-16"},[_c('img',{attrs:{"src":require("../assets/Stop-Logo.png"),"alt":"Stop"}}),_c('h1',[_vm._v(" "+_vm._s(_vm.$t('auth.NotAuthorized'))+" ")]),_c('p',[_vm._v(" "+_vm._s(_vm.$t('auth.YouAreNotAuthorizedToViewThisPage'))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }